import type { DbOperationEnded } from '@papan/types'

/**
 * #1101 — the DB editor's notice for a background db operation that ended (`DbOperationEnded`): its `collab` i18n key,
 * or null for an operation / outcome this build has no copy for (shown nothing — the bell still carries it). A new
 * operation or outcome adds its keys under `database.operationEnded.*` in every locale, and its case here.
 */
export function dbOperationNoticeKey(op: DbOperationEnded): string | null {
  if (op.operation === 'version-save' && op.outcome === 'not-saved') {
    if (op.reason === 'too-large') return 'database.operationEnded.versionSave.notSaved.tooLarge'
    if (op.reason === 'superseded') return 'database.operationEnded.versionSave.notSaved.superseded'
    return 'database.operationEnded.versionSave.notSaved.refused'
  }
  // #1090 — a large Replace run in the background.
  if (op.operation === 'replace') {
    if (op.outcome === 'replaced') return op.reason === 'damaged' ? 'database.operationEnded.replace.replacedDamaged' : 'database.operationEnded.replace.replaced'
    if (op.outcome === 'failed') return op.reason === 'resolved' ? 'database.operationEnded.replace.failedResolved' : 'database.operationEnded.replace.failed'
    if (op.outcome === 'not-applied') {
      const reason = op.reason === 'invalid' || op.reason === 'busy' || op.reason === 'gone' || op.reason === 'error' || op.reason === 'resolved' ? op.reason : 'refused'
      return `database.operationEnded.replace.notApplied.${reason}`
    }
  }
  return null
}

/** #1090 — how the notice reads: a Replace that landed is good news; every other ending is a warning. */
export function dbOperationNoticeTone(op: DbOperationEnded): 'success' | 'warning' {
  return op.operation === 'replace' && op.outcome === 'replaced' && op.reason !== 'damaged' ? 'success' : 'warning'
}
